import * as _builtinModules2 from "builtin-modules";
var _builtinModules = "default" in _builtinModules2 ? _builtinModules2.default : _builtinModules2;
var exports = {};
const builtinModules = _builtinModules;
const moduleSet = new Set(builtinModules);
const NODE_PROTOCOL = "node:";
exports = moduleName => {
  if (typeof moduleName !== "string") {
    throw new TypeError("Expected a string");
  }
  if (moduleName.startsWith(NODE_PROTOCOL)) {
    moduleName = moduleName.slice(NODE_PROTOCOL.length);
  }
  const slashIndex = moduleName.indexOf("/");
  if (slashIndex !== -1 && slashIndex !== moduleName.length - 1) {
    moduleName = moduleName.slice(0, slashIndex);
  }
  return moduleSet.has(moduleName);
};
export default exports;